import { Icon, Layout, Menu } from 'antd';
import { push } from 'connected-react-router';
import { bool, func, shape, string } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
// import Settings from '../../../../components/Settings';
import logOutMovement from '../../../../redux/movements/authMovements';
import {
  collapseSiderMovement,
  hideSiderMovement,
  toggleSiderMovement,
} from '../../../../redux/movements/layoutMovements';
// import { showModalMovement } from '../../../../redux/movements/modalMovements';
import { authSelector } from '../../../../redux/reducers/authReducer/authSelectors';
import '../privateLayout.scss';
import './Sider.scss';
import menuCreator from './menuCreator';
import rolePaths from './rolePaths';
import { t } from '../../../../utils/helperFunctions';

const PrivateSider = ({
  auth: { role },
  pathname,
  goTo,
  logOut,
  // openSettings,
  toggleSider,
  hideSider,
  collapsedSider,
  collapsed,
  visible,
}) => {
  const toggle = () => {
    if (window.innerWidth < 992) {
      hideSider();
      collapsedSider();
    }
  };
  const renderMenu = () =>
    role
      ? menuCreator(rolePaths[role], goTo, toggle, collapsed, toggleSider)
      : [];

  const selected = `/${pathname.split('/')[1]}`;
  return (
    visible && (
      <Layout.Sider
        className={`${!collapsed ? 'open' : ''}`}
        breakpoint="lg"
        collapsedWidth="113"
        trigger={null}
        collapsed={collapsed && visible}
        width={visible ? '266' : '0'}
      >
        {/* Menu Header */}
        <div className="menu-header">
          <h2>{t('menu.menu')}</h2>
          <Icon type="close" onClick={toggleSider} />
          <Icon type="menu" onClick={toggleSider} />
        </div>

        {/* Menu Items */}
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={['/']}
          selectedKeys={[selected]}
        >
          {renderMenu()}
          {/* <Menu.Item key="settings" className="config" onClick={openSettings}>
            <span className="menu-title">
              <Icon type="tool" />
              <div className="menu-text">{t('menu.config')}</div>
            </span>
          </Menu.Item> */}
          <Menu.Item key="logout" className="logout" onClick={logOut}>
            <span className="menu-title">
              <Icon type="logout" />
              <div className="menu-text">{t('menu.exit')}</div>
            </span>
          </Menu.Item>
        </Menu>
      </Layout.Sider>
    )
  );
};

PrivateSider.propTypes = {
  auth: shape({
    role: string,
  }).isRequired,
  pathname: string.isRequired,
  goTo: func.isRequired,
  logOut: func.isRequired,
  toggleSider: func.isRequired,
  hideSider: func.isRequired,
  collapsedSider: func.isRequired,
  // openSettings: func.isRequired,
  collapsed: bool.isRequired,
  visible: bool.isRequired,
};

const mapStateToProps = (state) => ({
  auth: authSelector(state),
  pathname: state.router.location.pathname,
  collapsed: state.layout.sider.collapsed,
  visible: state.layout.sider.visible,
});

const mapDispatchToProps = {
  toggleSider: toggleSiderMovement,
  hideSider: hideSiderMovement,
  collapsedSider: collapseSiderMovement,
  goTo: push,
  logOut: logOutMovement,
  // openSettings: () => showModalMovement(Settings),
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivateSider);
